import React, { useState } from "react"
import { flowRight as compose } from "lodash"
import { useMutation } from "@apollo/react-hooks"
import {
  Alert,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Row,
  Button
} from "reactstrap"
import { FilePond, registerPlugin } from "react-filepond"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation"
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import { withBasicNotify } from "components/notification"
import { BarLoader } from "components/spinner"
import { IMPORT_FILE } from "./gql"

const UploadSection = (props) => {
  registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

  const [file, setFile] = useState(null)
  const [importFile] = useMutation(IMPORT_FILE)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const errorMessageDetails = []

  return (
    <Card>
      <CardHeader>匯入 [{props.typeName}] 資料</CardHeader>
      <CardBody className="ml-3">
        <Row>說明：{props.description}</Row>
        <Row className="mt-2">
          <a href={props.sampleUrl} target="_blank" rel="noopener noreferrer">
            下載格式範例
          </a>
        </Row>
      </CardBody>
      <CardFooter>
        <FilePond
          labelIdle='將檔案拖拉至此 或 <span class="filepond--label-action">瀏覽檔案</span>'
          allowMultiple={false}
          files={(file && [file]) || null}
          beforeAddFile={(item) => {
            return new Promise((resolve) => {
              if (
                item.file.type === "text/csv" ||
                item.file.name.includes(".csv")
              ) {
                setFile(item.file)
                return resolve(true)
              }
              props.notify.warn("請上傳 csv 格式")

              return resolve(false)
            })
          }}
          beforeRemoveFile={() => {
            setFile(null)
          }}
        />
        <Button
          color="primary"
          className="mb-2"
          disabled={!file}
          onClick={async () => {
            setLoading(true)
            try {
              await importFile({
                variables: { file, type: props.uploadType }
              })

              props.notify.success("上傳成功")
              setErrorMessage([])
            } catch (e) {
              const error = JSON.parse(
                e?.message.replace("GraphQL error: ", "")
              )

              Object.keys(error).forEach((key) => {
                errorMessageDetails.push(
                  `第${key}列   :      ${error[key].join(
                    ",       "
                  )}              `
                )
              })

              setErrorMessage(errorMessageDetails)
            }
            setLoading(false)
            setFile(null)
          }}
        >
          上傳
        </Button>
        <BarLoader loading={loading} />
        {errorMessage.map((list) => (
          <Alert color="danger" className="my-2">
            <div className="icon">
              <FontAwesomeIcon icon={faExclamationTriangle} /> {list}
            </div>
          </Alert>
        ))}
      </CardFooter>
    </Card>
  )
}

export default compose(withBasicNotify)(UploadSection)
